var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSlippageDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16504 12.1282H13.0001",
    stroke: "#575C63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52001 1.02986C8.0371 0.411858 8.96666 0.321237 9.59748 0.827822C9.63236 0.855305 10.753 1.72586 10.753 1.72586C11.446 2.14479 11.6613 3.0354 11.2329 3.71506C11.2102 3.75146 4.87463 11.6763 4.87463 11.6763C4.66385 11.9393 4.34389 12.0945 4.00194 12.0982L1.57569 12.1287L1.02902 9.81488C0.952442 9.48953 1.02902 9.14785 1.2398 8.8849L7.52001 1.02986Z",
    stroke: "#575C63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34717 2.50098L9.982 5.29239",
    stroke: "#575C63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSlippageDisabled);
export default __webpack_public_path__ + "static/media/edit-slippage-disabled.12696f27cf286a361f0575d9dd3af344.svg";
export { ForwardRef as ReactComponent };